@import 'styles/mixins';
@import 'styles/variables';

.dropdownContainer {
  background: #ffffff;
  border-radius: 8px;
  padding: 8px;
  width: 136px;
  @include shadow-2;
}

.alignmentOptions {
  @include md-regular;

  display: flex;
  flex-direction: column;

  .alignmentOption {
    color: $grey-40;
    display: flex;
    height: 30px;
    margin-bottom: 5px;

    &:last-child {
      margin-bottom: 0;
    }

    .alignmentIcon {
      margin: auto 4px auto 0;
      fill: #8f98a9;
    }

    .alignmentLabel {
      align-items: center;
      display: flex;
      height: 24px;
      margin: auto 0;
    }
  }

  .alignmentOption:focus,
  .alignmentOption:hover {
    outline: none;
    &.active {
      background: $blue-10;
    }
  }

  .active,
  .alignmentOption:focus,
  .alignmentOption:hover {
    background: $grey-5;
    border-radius: 4px;
    cursor: pointer;
  }

  .active {
    background: $blue-5;
    color: $blue-50;
  }
}
